import PageNewTemplate from "../../templates/PageNewTemplate/PageNewTemplate";

const PageNewPage = () => {
  return <PageNewTemplate />;
};

export default PageNewPage;
